<div class="filters-new-design">
  <mat-form-field class="filter-field" appearance="outline">
    <mat-label>Select country</mat-label>
    <mat-select class="mat-select-no-arrow" [value]="selectedCountry">
      <mat-select-trigger>
        <img class="mr-4" [src]="selectedCountry?.flagImageURL" width="24" alt="{{selectedCountry?.name}}">
        <span>{{ selectedCountry?.name || '' }}</span>
      </mat-select-trigger>

      <mat-option>
        <ngx-mat-select-search [formControl]="searchFilterCtrl"
                               [placeholderLabel]="'Search...'"
                               [noEntriesFoundLabel]="'No supported country found'">
        </ngx-mat-select-search>
      </mat-option>

      <mat-option *ngFor="let country of filteredCountries | async"
                  [value]="country"
                  (onSelectionChange)="selectCountry(country)">
        <img class="mr-4" [src]="country.flagImageURL" width="24" alt="{{country.name}}">
        {{ country.name }} - {{ country.alpha3Code }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
